// extracted by mini-css-extract-plugin
module.exports = {"AboutPage":"AboutPage_AboutPage__5jfyb","Info":"AboutPage_Info__3WfmX","Team":"AboutPage_Team__1tSwU","Member":"AboutPage_Member__3Vdlb"};